package com.essntl.core.whatsapp.data.response

import com.essntl.features.message.domain.model.LinkPreviewModel
import kotlinx.serialization.Serializable

@Serializable
data class LinkPreviewDto(
    val body: String,
    val url: String,
) {
    fun toModel() =
        LinkPreviewModel(
            body = body,
            url = url,
        )
}
